// import React, { useState, useRef, useCallback, useEffect } from 'react';

// const BloggerEditor = () => {
//   const [content, setContent] = useState('');
//   const [showImageDropdown, setShowImageDropdown] = useState(false);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
//   const [showColorPicker, setShowColorPicker] = useState(false);
//   const [activeFormats, setActiveFormats] = useState({});
//   const editorRef = useRef(null);
//   const fileInputRef = useRef(null);

//   useEffect(() => {
//     if (editorRef.current && !editorRef.current.innerHTML) {
//       editorRef.current.innerHTML = '<p><br></p>';
//     }
//   }, []);

//   // Check active formatting states
//   const checkActiveFormats = useCallback(() => {
//     try {
//       const formats = {
//         bold: document.queryCommandState('bold'),
//         italic: document.queryCommandState('italic'),
//         underline: document.queryCommandState('underline'),
//         strikeThrough: document.queryCommandState('strikeThrough'),
//         justifyLeft: document.queryCommandState('justifyLeft'),
//         justifyCenter: document.queryCommandState('justifyCenter'),
//         justifyRight: document.queryCommandState('justifyRight'),
//         justifyFull: document.queryCommandState('justifyFull'),
//         insertUnorderedList: document.queryCommandState('insertUnorderedList'),
//         insertOrderedList: document.queryCommandState('insertOrderedList')
//       };
//       setActiveFormats(formats);
//     } catch (e) {
//       // Ignore errors
//     }
//   }, []);

//   const execCommand = useCallback((command, value = null) => {
//     document.execCommand(command, false, value);
//     editorRef.current?.focus();
//     updateContent();
//     setTimeout(checkActiveFormats, 10);
//   }, [checkActiveFormats]);

//   const updateContent = useCallback(() => {
//     if (editorRef.current) {
//       setContent(editorRef.current.innerHTML);
//     }
//   }, []);

//   const handleImageUpload = () => {
//     fileInputRef.current?.click();
//   };

//   const insertImage = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         const img = document.createElement('img');
//         img.src = e.target.result;
//         // Default image styles - centered by default as requested
//         img.style.maxWidth = '320px';
//         img.style.height = 'auto';
//         img.style.display = 'block';
//         img.style.margin = '8px auto';
//         img.style.cursor = 'pointer';
//         img.style.border = '1px solid transparent';
//         img.setAttribute('data-image-id', Date.now().toString());
        
//         img.onclick = (event) => {
//           event.stopPropagation();
//           const rect = img.getBoundingClientRect();
//           const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//           const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
//           const containerRect = editorRef.current.getBoundingClientRect();
          
//           // Calculate position relative to viewport, ensuring dropdown stays within editor bounds
//           let dropdownTop = rect.bottom + scrollTop + 5;
//           let dropdownLeft = rect.left + scrollLeft;
          
//           // Adjust if dropdown would go outside container bounds
//           const dropdownWidth = 200; // approximate dropdown width
//           if (dropdownLeft + dropdownWidth > containerRect.right + scrollLeft) {
//             dropdownLeft = rect.right + scrollLeft - dropdownWidth;
//           }
          
//           setDropdownPosition({
//             top: dropdownTop,
//             left: dropdownLeft
//           });
//           setSelectedImage(img);
//           setShowImageDropdown(true);
//         };
        
//         // Insert image properly and position cursor after it
//         const selection = window.getSelection();
//         if (selection.rangeCount > 0) {
//           const range = selection.getRangeAt(0);
//           range.deleteContents(); // Clear any selected content first
//           range.insertNode(img);
          
//           // Create a new paragraph after the image and position cursor there
//           const newParagraph = document.createElement('p');
//           newParagraph.innerHTML = '<br>';
          
//           // Insert the paragraph after the image
//           if (img.nextSibling) {
//             img.parentNode.insertBefore(newParagraph, img.nextSibling);
//           } else {
//             img.parentNode.appendChild(newParagraph);
//           }
          
//           // Position cursor at the beginning of the new paragraph
//           range.setStart(newParagraph, 0);
//           range.setEnd(newParagraph, 0);
//           selection.removeAllRanges();
//           selection.addRange(range);
          
//         } else {
//           // Fallback if no selection
//           editorRef.current?.appendChild(img);
//           const newParagraph = document.createElement('p');
//           newParagraph.innerHTML = '<br>';
//           editorRef.current?.appendChild(newParagraph);
//         }
        
//         updateContent();
//       };
//       reader.readAsDataURL(file);
//     }
//     event.target.value = '';
//   };

//   const resizeImage = (width) => {
//     if (selectedImage) {
//       // Reset and set new size properly
//       selectedImage.style.maxWidth = '';
//       selectedImage.style.width = '';
      
//       if (width === 'original') {
//         selectedImage.style.maxWidth = '100%';
//       } else if (width === 'small') {
//         selectedImage.style.maxWidth = '200px';
//       } else if (width === 'medium') {
//         selectedImage.style.maxWidth = '320px';
//       } else if (width === 'large') {
//         selectedImage.style.maxWidth = '400px';
//       } else if (width === 'x-large') {
//         selectedImage.style.maxWidth = '640px';
//       }
      
//       updateContent();
//       setShowImageDropdown(false);
//     }
//   };

//   const alignImage = (alignment) => {
//     if (selectedImage) {
//       selectedImage.style.float = alignment === 'left' ? 'left' :
//                                  alignment === 'right' ? 'right' : 'none';
      
//       if (alignment === 'center') {
//         selectedImage.style.display = 'block';
//         selectedImage.style.margin = '8px auto';
//       } else {
//         selectedImage.style.display = 'inline';
//         selectedImage.style.margin = alignment === 'left' ? '8px 16px 8px 0' :
//                                    alignment === 'right' ? '8px 0 8px 16px' : '8px';
//       }
//       updateContent();
//       setShowImageDropdown(false);
//     }
//   };

//   const removeImage = () => {
//     if (selectedImage) {
//       selectedImage.remove();
//       updateContent();
//       setShowImageDropdown(false);
//       setSelectedImage(null);
//     }
//   };

//   const insertLink = () => {
//     const url = prompt('Enter link URL:');
//     if (url) {
//       execCommand('createLink', url);
//     }
//   };

//   const changeTextColor = (color) => {
//     execCommand('foreColor', color);
//     setShowColorPicker(false);
//   };

//   const changeBackgroundColor = (color) => {
//     execCommand('backColor', color);
//     setShowColorPicker(false);
//   };

//   const insertTable = () => {
//     const rows = prompt('Number of rows:', '3');
//     const cols = prompt('Number of columns:', '3');
//     if (rows && cols) {
//       let tableHTML = '<table border="1" style="border-collapse: collapse; width: 100%;">';
//       for (let i = 0; i < parseInt(rows); i++) {
//         tableHTML += '<tr>';
//         for (let j = 0; j < parseInt(cols); j++) {
//           tableHTML += '<td style="padding: 8px; border: 1px solid #ccc;">&nbsp;</td>';
//         }
//         tableHTML += '</tr>';
//       }
//       tableHTML += '</table><p><br></p>';
//       execCommand('insertHTML', tableHTML);
//     }
//   };

//   const getCurrentImageProps = () => {
//     if (!selectedImage) return { size: 'medium', alignment: 'center' };
    
//     const maxWidth = selectedImage.style.maxWidth || '320px';
//     let size = 'medium';
    
//     if (maxWidth === '100%') size = 'original';
//     else if (maxWidth === '200px') size = 'small';
//     else if (maxWidth === '320px') size = 'medium';
//     else if (maxWidth === '400px') size = 'large';
//     else if (maxWidth === '640px') size = 'x-large';

//     const float = selectedImage.style.float || 'none';
//     const isCenter = selectedImage.style.display === 'block' && selectedImage.style.margin.includes('auto');
//     const alignment = isCenter ? 'center' : float;

//     return { size, alignment };
//   };

//   const currentProps = selectedImage ? getCurrentImageProps() : { size: 'medium', alignment: 'center' };

//   const colors = [
//     '#000000', '#444444', '#666666', '#999999', '#cccccc', '#eeeeee', '#f3f3f3', '#ffffff',
//     '#ff0000', '#ff9900', '#ffff00', '#00ff00', '#00ffff', '#0000ff', '#9900ff', '#ff00ff',
//     '#f4cccc', '#fce5cd', '#fff2cc', '#d9ead3', '#d0e0e3', '#cfe2f3', '#d9d2e9', '#ead1dc',
//     '#ea9999', '#f9cb9c', '#ffe599', '#b6d7a8', '#a2c4c9', '#9fc5e8', '#b4a7d6', '#d5a6bd'
//   ];

//   const editorStyles = {
//     container: {
//       maxWidth: '900px',
//       margin: '10px auto',
//       fontFamily: 'Arial, sans-serif',
//       backgroundColor: '#fff'
//     },
//     editorWrapper: {
//       border: '1px solid #d0d0d0',
//       borderRadius: '2px',
//       backgroundColor: '#fff',
//       boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//     },
//     toolbar: {
//       padding: '8px',
//       backgroundColor: '#f8f8f8',
//       borderBottom: '1px solid #d0d0d0',
//       display: 'flex',
//       alignItems: 'center',
//       flexWrap: 'wrap',
//       gap: '4px'
//     },
//     toolbarGroup: {
//       display: 'flex',
//       alignItems: 'center',
//       marginRight: '8px',
//       paddingRight: '8px',
//       borderRight: '1px solid #d0d0d0'
//     },
//     toolbarButton: (isActive = false) => ({
//       padding: '6px 8px',
//       border: isActive ? '1px solid #1a73e8' : '1px solid transparent',
//       backgroundColor: isActive ? '#e8f0fe' : 'transparent',
//       borderRadius: '2px',
//       cursor: 'pointer',
//       fontSize: '14px',
//       color: isActive ? '#1a73e8' : '#444',
//       marginRight: '2px',
//       minWidth: '28px',
//       height: '28px',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center'
//     }),
//     select: {
//       padding: '4px 6px',
//       border: '1px solid #d0d0d0',
//       borderRadius: '2px',
//       fontSize: '13px',
//       backgroundColor: '#fff',
//       marginRight: '4px',
//       height: '28px'
//     },
//     editor: {
//       minHeight: '400px',
//       padding: '12px',
//       outline: 'none',
//       lineHeight: '1.4',
//       fontSize: '13px',
//       fontFamily: 'arial, sans-serif',
//       backgroundColor: '#fff',
//       cursor: 'text'
//     },
//     imageDropdown: {
//       position: 'fixed',
//       backgroundColor: '#fff',
//       border: '1px solid #ccc',
//       borderRadius: '4px',
//       boxShadow: '0 4px 16px rgba(0,0,0,0.3)',
//       zIndex: 1000,
//       minWidth: '200px',
//       padding: '8px 0'
//     },
//     dropdownSection: {
//       padding: '8px 12px',
//       borderBottom: '1px solid #f0f0f0'
//     },
//     dropdownLabel: {
//       fontSize: '12px',
//       fontWeight: 'bold',
//       color: '#666',
//       marginBottom: '4px'
//     },
//     dropdownItem: {
//       padding: '6px 12px',
//       fontSize: '13px',
//       cursor: 'pointer',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '8px'
//     },
//     colorPicker: {
//       position: 'absolute',
//       backgroundColor: '#fff',
//       border: '1px solid #ccc',
//       borderRadius: '2px',
//       padding: '8px',
//       boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
//       zIndex: 1000,
//       display: 'grid',
//       gridTemplateColumns: 'repeat(8, 1fr)',
//       gap: '2px',
//       width: '200px'
//     },
//     colorSquare: {
//       width: '20px',
//       height: '20px',
//       cursor: 'pointer',
//       border: '1px solid #ccc'
//     }
//   };

//   return (
//     <div>
//       <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css" />
      
//       <div style={editorStyles.container}>
//         <div style={editorStyles.editorWrapper}>
//           {/* Blogger-style Toolbar */}
//           <div style={editorStyles.toolbar}>
//             {/* Font Size */}
//             <div style={editorStyles.toolbarGroup}>
//               <select 
//                 style={editorStyles.select}
//                 onChange={(e) => execCommand('fontSize', e.target.value)}
//                 defaultValue="3"
//                 title="Font size"
//               >
//                 <option value="1">10px</option>
//                 <option value="2">13px</option>
//                 <option value="3">16px</option>
//                 <option value="4">18px</option>
//                 <option value="5">24px</option>
//                 <option value="6">32px</option>
//                 <option value="7">48px</option>
//               </select>
//             </div>

//             {/* Formatting */}
//             <div style={editorStyles.toolbarGroup}>
//               <button 
//                 style={editorStyles.toolbarButton(activeFormats.bold)} 
//                 onClick={() => execCommand('bold')} 
//                 title="Bold"
//                 onMouseEnter={(e) => !activeFormats.bold && (e.target.style.backgroundColor = '#e8f0fe')}
//                 onMouseLeave={(e) => !activeFormats.bold && (e.target.style.backgroundColor = 'transparent')}
//               >
//                 <i className="fas fa-bold"></i>
//               </button>
//               <button 
//                 style={editorStyles.toolbarButton(activeFormats.italic)} 
//                 onClick={() => execCommand('italic')} 
//                 title="Italic"
//                 onMouseEnter={(e) => !activeFormats.italic && (e.target.style.backgroundColor = '#e8f0fe')}
//                 onMouseLeave={(e) => !activeFormats.italic && (e.target.style.backgroundColor = 'transparent')}
//               >
//                 <i className="fas fa-italic"></i>
//               </button>
//               <button 
//                 style={editorStyles.toolbarButton(activeFormats.underline)} 
//                 onClick={() => execCommand('underline')} 
//                 title="Underline"
//                 onMouseEnter={(e) => !activeFormats.underline && (e.target.style.backgroundColor = '#e8f0fe')}
//                 onMouseLeave={(e) => !activeFormats.underline && (e.target.style.backgroundColor = 'transparent')}
//               >
//                 <i className="fas fa-underline"></i>
//               </button>
//               <button 
//                 style={editorStyles.toolbarButton(activeFormats.strikeThrough)} 
//                 onClick={() => execCommand('strikeThrough')} 
//                 title="Strikethrough"
//                 onMouseEnter={(e) => !activeFormats.strikeThrough && (e.target.style.backgroundColor = '#e8f0fe')}
//                 onMouseLeave={(e) => !activeFormats.strikeThrough && (e.target.style.backgroundColor = 'transparent')}
//               >
//                 <i className="fas fa-strikethrough"></i>
//               </button>
//             </div>

//             {/* Colors */}
//             <div style={editorStyles.toolbarGroup}>
//               <div style={{position: 'relative'}}>
//                 <button 
//                   style={editorStyles.toolbarButton()}
//                   onClick={() => setShowColorPicker(!showColorPicker)}
//                   title="Text color"
//                 >
//                   <i className="fas fa-palette"></i>
//                 </button>
//                 {showColorPicker && (
//                   <div style={{...editorStyles.colorPicker, top: '32px', left: '0'}}>
//                     {colors.map(color => (
//                       <div 
//                         key={color}
//                         style={{...editorStyles.colorSquare, backgroundColor: color}}
//                         onClick={() => changeTextColor(color)}
//                         title={color}
//                       />
//                     ))}
//                   </div>
//                 )}
//               </div>
              
//               <button 
//                 style={editorStyles.toolbarButton()}
//                 onClick={() => execCommand('removeFormat')}
//                 title="Remove formatting"
//                 onMouseEnter={(e) => e.target.style.backgroundColor = '#e8f0fe'}
//                 onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
//               >
//                 <i className="fas fa-eraser"></i>
//               </button>
//             </div>

//             {/* Alignment */}
//             <div style={editorStyles.toolbarGroup}>
//               <button 
//                 style={editorStyles.toolbarButton(activeFormats.justifyLeft)} 
//                 onClick={() => execCommand('justifyLeft')} 
//                 title="Align left"
//                 onMouseEnter={(e) => !activeFormats.justifyLeft && (e.target.style.backgroundColor = '#e8f0fe')}
//                 onMouseLeave={(e) => !activeFormats.justifyLeft && (e.target.style.backgroundColor = 'transparent')}
//               >
//                 <i className="fas fa-align-left"></i>
//               </button>
//               <button 
//                 style={editorStyles.toolbarButton(activeFormats.justifyCenter)} 
//                 onClick={() => execCommand('justifyCenter')} 
//                 title="Center"
//                 onMouseEnter={(e) => !activeFormats.justifyCenter && (e.target.style.backgroundColor = '#e8f0fe')}
//                 onMouseLeave={(e) => !activeFormats.justifyCenter && (e.target.style.backgroundColor = 'transparent')}
//               >
//                 <i className="fas fa-align-center"></i>
//               </button>
//               <button 
//                 style={editorStyles.toolbarButton(activeFormats.justifyRight)} 
//                 onClick={() => execCommand('justifyRight')} 
//                 title="Align right"
//                 onMouseEnter={(e) => !activeFormats.justifyRight && (e.target.style.backgroundColor = '#e8f0fe')}
//                 onMouseLeave={(e) => !activeFormats.justifyRight && (e.target.style.backgroundColor = 'transparent')}
//               >
//                 <i className="fas fa-align-right"></i>
//               </button>
//               <button 
//                 style={editorStyles.toolbarButton(activeFormats.justifyFull)} 
//                 onClick={() => execCommand('justifyFull')} 
//                 title="Justify"
//                 onMouseEnter={(e) => !activeFormats.justifyFull && (e.target.style.backgroundColor = '#e8f0fe')}
//                 onMouseLeave={(e) => !activeFormats.justifyFull && (e.target.style.backgroundColor = 'transparent')}
//               >
//                 <i className="fas fa-align-justify"></i>
//               </button>
//             </div>

//             {/* Lists */}
//             <div style={editorStyles.toolbarGroup}>
//               <button 
//                 style={editorStyles.toolbarButton(activeFormats.insertUnorderedList)} 
//                 onClick={() => execCommand('insertUnorderedList')} 
//                 title="Bullet list"
//                 onMouseEnter={(e) => !activeFormats.insertUnorderedList && (e.target.style.backgroundColor = '#e8f0fe')}
//                 onMouseLeave={(e) => !activeFormats.insertUnorderedList && (e.target.style.backgroundColor = 'transparent')}
//               >
//                 <i className="fas fa-list-ul"></i>
//               </button>
//               <button 
//                 style={editorStyles.toolbarButton(activeFormats.insertOrderedList)} 
//                 onClick={() => execCommand('insertOrderedList')} 
//                 title="Numbered list"
//                 onMouseEnter={(e) => !activeFormats.insertOrderedList && (e.target.style.backgroundColor = '#e8f0fe')}
//                 onMouseLeave={(e) => !activeFormats.insertOrderedList && (e.target.style.backgroundColor = 'transparent')}
//               >
//                 <i className="fas fa-list-ol"></i>
//               </button>
//               <button 
//                 style={editorStyles.toolbarButton()}
//                 onClick={() => execCommand('indent')} 
//                 title="Increase indent"
//                 onMouseEnter={(e) => e.target.style.backgroundColor = '#e8f0fe'}
//                 onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
//               >
//                 <i className="fas fa-indent"></i>
//               </button>
//               <button 
//                 style={editorStyles.toolbarButton()}
//                 onClick={() => execCommand('outdent')} 
//                 title="Decrease indent"
//                 onMouseEnter={(e) => e.target.style.backgroundColor = '#e8f0fe'}
//                 onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
//               >
//                 <i className="fas fa-outdent"></i>
//               </button>
//             </div>

//             {/* Insert */}
//             <div style={editorStyles.toolbarGroup}>
//               <button 
//                 style={editorStyles.toolbarButton()}
//                 onClick={insertLink} 
//                 title="Insert link"
//                 onMouseEnter={(e) => e.target.style.backgroundColor = '#e8f0fe'}
//                 onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
//               >
//                 <i className="fas fa-link"></i>
//               </button>
//               <button 
//                 style={editorStyles.toolbarButton()}
//                 onClick={handleImageUpload} 
//                 title="Insert image"
//                 onMouseEnter={(e) => e.target.style.backgroundColor = '#e8f0fe'}
//                 onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
//               >
//                 <i className="fas fa-image"></i>
//               </button>
//               <button 
//                 style={editorStyles.toolbarButton()}
//                 onClick={insertTable} 
//                 title="Insert table"
//                 onMouseEnter={(e) => e.target.style.backgroundColor = '#e8f0fe'}
//                 onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
//               >
//                 <i className="fas fa-table"></i>
//               </button>
//             </div>

//             {/* Undo/Redo */}
//             <div style={editorStyles.toolbarGroup}>
//               <button 
//                 style={editorStyles.toolbarButton()}
//                 onClick={() => execCommand('undo')} 
//                 title="Undo"
//                 onMouseEnter={(e) => e.target.style.backgroundColor = '#e8f0fe'}
//                 onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
//               >
//                 <i className="fas fa-undo"></i>
//               </button>
//               <button 
//                 style={editorStyles.toolbarButton()}
//                 onClick={() => execCommand('redo')} 
//                 title="Redo"
//                 onMouseEnter={(e) => e.target.style.backgroundColor = '#e8f0fe'}
//                 onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
//               >
//                 <i className="fas fa-redo"></i>
//               </button>
//             </div>
//           </div>
          
//           {/* Editor Area */}
//           <div
//             ref={editorRef}
//             contentEditable
//             style={editorStyles.editor}
//             onInput={updateContent}
//             onKeyUp={checkActiveFormats}
//             onMouseUp={checkActiveFormats}
//             suppressContentEditableWarning={true}
//             onClick={() => {
//               setShowColorPicker(false);
//               setShowImageDropdown(false);
//               setTimeout(checkActiveFormats, 10);
//             }}
//           />
          
//           <input
//             ref={fileInputRef}
//             type="file"
//             accept="image/*"
//             onChange={insertImage}
//             style={{display: 'none'}}
//           />
//         </div>

//         {/* Image Dropdown */}
//         {showImageDropdown && selectedImage && (
//           <>
//             {/* Backdrop */}
//             <div 
//               style={{
//                 position: 'fixed',
//                 top: 0,
//                 left: 0,
//                 right: 0,
//                 bottom: 0,
//                 zIndex: 999
//               }}
//               onClick={() => setShowImageDropdown(false)}
//             />
            
//             {/* Dropdown */}
//             <div 
//               style={{
//                 ...editorStyles.imageDropdown,
//                 top: dropdownPosition.top,
//                 left: dropdownPosition.left
//               }}
//               onClick={(e) => e.stopPropagation()}
//             >
//               <div style={editorStyles.dropdownSection}>
//                 <div style={editorStyles.dropdownLabel}>Size:</div>
//                 {[
//                   {label: 'Small', value: 'small'},
//                   {label: 'Medium', value: 'medium'},
//                   {label: 'Large', value: 'large'},
//                   {label: 'X-Large', value: 'x-large'},
//                   {label: 'Original size', value: 'original'}
//                 ].map(size => (
//                   <div 
//                     key={size.value}
//                     style={{
//                       ...editorStyles.dropdownItem,
//                       backgroundColor: currentProps.size === size.value ? '#e8f0fe' : 'transparent',
//                       color: currentProps.size === size.value ? '#1a73e8' : '#333'
//                     }}
//                     onClick={() => resizeImage(size.value)}
//                     onMouseEnter={(e) => currentProps.size !== size.value && (e.target.style.backgroundColor = '#f5f5f5')}
//                     onMouseLeave={(e) => currentProps.size !== size.value && (e.target.style.backgroundColor = 'transparent')}
//                   >
//                     {size.label} {currentProps.size === size.value && '✓'}
//                   </div>
//                 ))}
//               </div>

//               <div style={editorStyles.dropdownSection}>
//                 <div style={editorStyles.dropdownLabel}>Alignment:</div>
//                 {[
//                   {label: 'Left', value: 'left'},
//                   {label: 'Center', value: 'center'},
//                   {label: 'Right', value: 'right'},
//                   {label: 'None', value: 'none'}
//                 ].map(align => (
//                   <div 
//                     key={align.value}
//                     style={{
//                       ...editorStyles.dropdownItem,
//                       backgroundColor: currentProps.alignment === align.value ? '#e8f0fe' : 'transparent',
//                       color: currentProps.alignment === align.value ? '#1a73e8' : '#333'
//                     }}
//                     onClick={() => alignImage(align.value)}
//                     onMouseEnter={(e) => currentProps.alignment !== align.value && (e.target.style.backgroundColor = '#f5f5f5')}
//                     onMouseLeave={(e) => currentProps.alignment !== align.value && (e.target.style.backgroundColor = 'transparent')}
//                   >
//                     {align.label} {currentProps.alignment === align.value && '✓'}
//                   </div>
//                 ))}
//               </div>

//               <div style={{borderTop: '1px solid #f0f0f0'}}>
//                 <div 
//                   style={{
//                     ...editorStyles.dropdownItem,
//                     color: '#d93025'
//                   }}
//                   onClick={removeImage}
//                   onMouseEnter={(e) => e.target.style.backgroundColor = '#fce8e6'}
//                   onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
//                 >
//                   Remove Image
//                 </div>
//               </div>
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default BloggerEditor;

// import React, { useState, useRef, useCallback, useEffect } from 'react';
// import './test.css';

// const BloggerEditor = () => {
//   const [content, setContent] = useState('');
//   const [showImageDropdown, setShowImageDropdown] = useState(false);
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [selectedVideo, setSelectedVideo] = useState(null);
//   const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
//   const [showColorPicker, setShowColorPicker] = useState(false);
//   const [activeFormats, setActiveFormats] = useState({});
//   const editorRef = useRef(null);
//   const fileInputRef = useRef(null);

//   // Define updateContent first
//   const updateContent = useCallback(() => {
//     if (editorRef.current) {
//       setContent(editorRef.current.innerHTML);
//     }
//   }, []);

//   // Check active formatting states
//   const checkActiveFormats = useCallback(() => {
//     try {
//       const formats = {
//         bold: document.queryCommandState('bold'),
//         italic: document.queryCommandState('italic'),
//         underline: document.queryCommandState('underline'),
//         strikeThrough: document.queryCommandState('strikeThrough'),
//         justifyLeft: document.queryCommandState('justifyLeft'),
//         justifyCenter: document.queryCommandState('justifyCenter'),
//         justifyRight: document.queryCommandState('justifyRight'),
//         justifyFull: document.queryCommandState('justifyFull'),
//         insertUnorderedList: document.queryCommandState('insertUnorderedList'),
//         insertOrderedList: document.queryCommandState('insertOrderedList')
//       };
//       setActiveFormats(formats);
//     } catch (e) {
//       // Ignore errors
//     }
//   }, []);

//   const execCommand = useCallback((command, value = null) => {
//     document.execCommand(command, false, value);
//     editorRef.current?.focus();
//     updateContent();
//     setTimeout(checkActiveFormats, 10);
//   }, [checkActiveFormats, updateContent]);

//   useEffect(() => {
//     if (editorRef.current && !editorRef.current.innerHTML) {
//       editorRef.current.innerHTML = '<p><br></p>';
//     }

//     // Add paste event listener to sanitize content
//     const handlePaste = (e) => {
//       e.preventDefault();
      
//       // Get plain text from clipboard
//       const text = (e.clipboardData || window.clipboardData).getData('text');
      
//       // Insert plain text without any formatting
//       document.execCommand('insertText', false, text);
      
//       // Update content after paste
//       setTimeout(updateContent, 10);
//     };

//     // Add click handlers for existing videos on initialization
//     const setupExistingVideos = () => {
//       const existingVideos = editorRef.current?.querySelectorAll('.video-container');
//       existingVideos?.forEach(video => {
//         setupVideoHandlers(video);
//       });
//     };

//     const editor = editorRef.current;
//     if (editor) {
//       editor.addEventListener('paste', handlePaste);
//       setupExistingVideos();
      
//       // Cleanup
//       return () => {
//         editor.removeEventListener('paste', handlePaste);
//       };
//     }
//   }, [updateContent]);

//   const handleImageUpload = () => {
//     fileInputRef.current?.click();
//   };

//   const insertImage = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         const img = document.createElement('img');
//         img.src = e.target.result;
//         img.className = 'editor-image';
//         img.style.maxWidth = '50%';
//         img.style.height = 'auto';
//         img.style.display = 'block';
//         img.style.margin = '8px auto';
//         img.setAttribute('data-image-id', Date.now().toString());
        
//         img.onclick = (event) => {
//           event.stopPropagation();
          
//           // Remove previous selection
//           const prevSelected = editorRef.current?.querySelector('.editor-image.selected');
//           if (prevSelected) {
//             prevSelected.classList.remove('selected');
//           }
          
//           // Add selection to current image
//           img.classList.add('selected');
          
//           const rect = img.getBoundingClientRect();
//           const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//           const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
          
//           // Position dropdown at bottom of image, centered
//           let dropdownTop = rect.bottom + scrollTop + 5;
//           let dropdownLeft = rect.left + scrollLeft + (rect.width / 2) - 80; // Center dropdown (160px width / 2 = 80)
          
//           // Ensure dropdown stays within viewport
//           const dropdownWidth = 160;
//           const dropdownHeight = 120;
//           const viewportWidth = window.innerWidth;
//           const viewportHeight = window.innerHeight;
          
//           if (dropdownLeft < 10) {
//             dropdownLeft = 10;
//           }
//           if (dropdownLeft + dropdownWidth > viewportWidth - 10) {
//             dropdownLeft = viewportWidth - dropdownWidth - 10;
//           }
          
//           if (dropdownTop + dropdownHeight > viewportHeight + scrollTop) {
//             dropdownTop = rect.top + scrollTop - dropdownHeight - 5;
//           }
          
//           setDropdownPosition({ top: dropdownTop, left: dropdownLeft });
//           setSelectedImage(img);
//           setShowImageDropdown(true);
//         };
        
//         // Insert image at cursor position
//         const selection = window.getSelection();
//         if (selection.rangeCount > 0) {
//           const range = selection.getRangeAt(0);
//           range.deleteContents();
//           range.insertNode(img);
          
//           const newParagraph = document.createElement('p');
//           newParagraph.innerHTML = '<br>';
          
//           if (img.nextSibling) {
//             img.parentNode.insertBefore(newParagraph, img.nextSibling);
//           } else {
//             img.parentNode.appendChild(newParagraph);
//           }
          
//           range.setStart(newParagraph, 0);
//           range.setEnd(newParagraph, 0);
//           selection.removeAllRanges();
//           selection.addRange(range);
//         } else {
//           editorRef.current?.appendChild(img);
//           const newParagraph = document.createElement('p');
//           newParagraph.innerHTML = '<br>';
//           editorRef.current?.appendChild(newParagraph);
//         }
        
//         updateContent();
//       };
//       reader.readAsDataURL(file);
//     }
//     event.target.value = '';
//   };

//   const formatHeading = (level) => {
//     if (level === 'p') {
//       execCommand('formatBlock', '<p>');
//     } else {
//       execCommand('formatBlock', `<h${level}>`);
//     }
//   };

//   const resizeImage = (width) => {
//     if (selectedImage) {
//       selectedImage.style.maxWidth = '';
//       selectedImage.style.width = '';
      
//       switch (width) {
//         case '25':
//           selectedImage.style.maxWidth = '25%';
//           break;
//         case '50':
//           selectedImage.style.maxWidth = '50%';
//           break;
//         case '75':
//           selectedImage.style.maxWidth = '75%';
//           break;
//         case '100':
//           selectedImage.style.maxWidth = '100%';
//           break;
//       }
      
//       updateContent();
//       setShowImageDropdown(false);
//     }
//   };

//   const alignImage = (alignment) => {
//     if (selectedImage) {
//       // Reset styles first
//       selectedImage.style.float = 'none';
//       selectedImage.style.display = 'block';
//       selectedImage.style.margin = '8px auto';
      
//       // Get the current max-width percentage
//       const currentMaxWidth = selectedImage.style.maxWidth || '50%';
      
//       switch (alignment) {
//         case 'left':
//           selectedImage.style.float = 'left';
//           selectedImage.style.display = 'inline';
//           selectedImage.style.margin = '8px 16px 8px 0';
//           // Ensure floated images don't exceed reasonable width
//           const leftMaxWidth = currentMaxWidth === '100%' ? '60%' : currentMaxWidth;
//           selectedImage.style.maxWidth = leftMaxWidth;
//           break;
//         case 'right':
//           selectedImage.style.float = 'right';
//           selectedImage.style.display = 'inline';
//           selectedImage.style.margin = '8px 0 8px 16px';
//           // Ensure floated images don't exceed reasonable width
//           const rightMaxWidth = currentMaxWidth === '100%' ? '60%' : currentMaxWidth;
//           selectedImage.style.maxWidth = rightMaxWidth;
//           break;
//         case 'center':
//           selectedImage.style.display = 'block';
//           selectedImage.style.margin = '8px auto';
//           selectedImage.style.maxWidth = currentMaxWidth;
//           break;
//         case 'none':
//           selectedImage.style.display = 'inline';
//           selectedImage.style.margin = '8px';
//           selectedImage.style.maxWidth = currentMaxWidth;
//           break;
//       }
      
//       updateContent();
//       setShowImageDropdown(false);
//     }
//   };

//   const removeImage = () => {
//     if (selectedImage) {
//       selectedImage.remove();
//       updateContent();
//       setShowImageDropdown(false);
//       setSelectedImage(null);
//     }
//   };

//   const insertLink = () => {
//     const url = prompt('Enter link URL:');
//     if (url) {
//       execCommand('createLink', url);
//     }
//   };

//   const insertYouTube = () => {
//     const url = prompt('Enter YouTube URL:');
//     if (url) {
//       let videoId = '';
      
//       // Extract video ID from various YouTube URL formats
//       const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
//       const match = url.match(regExp);
      
//       if (match && match[2].length === 11) {
//         videoId = match[2];
//       } else {
//         alert('Invalid YouTube URL. Please enter a valid YouTube video URL.');
//         return;
//       }
      
//       // Create video container with unique ID
//       const containerId = `video-${Date.now()}`;
//       const embedHTML = `
//         <div class="video-container" data-video-id="${containerId}" style="width: 75%; margin: 12px auto;">
//           <div class="video-wrapper">
//             <iframe 
//               src="https://www.youtube.com/embed/${videoId}" 
//               frameborder="0" 
//               allowfullscreen>
//             </iframe>
//           </div>
//         </div>
//         <p><br></p>
//       `;
      
//       execCommand('insertHTML', embedHTML);
      
//       // Add click handlers to the newly inserted video after a short delay
//       setTimeout(() => {
//         const videoContainer = editorRef.current?.querySelector(`[data-video-id="${containerId}"]`);
//         if (videoContainer) {
//           setupVideoHandlers(videoContainer);
//         }
//       }, 100);
//     }
//   };

//   const setupVideoHandlers = (videoContainer) => {
//     videoContainer.onclick = (event) => {
//       event.stopPropagation();
      
//       // Remove previous video selection
//       const prevSelected = editorRef.current?.querySelector('.video-container.selected');
//       if (prevSelected) {
//         prevSelected.classList.remove('selected');
//       }
      
//       // Add selection to current video
//       videoContainer.classList.add('selected');
      
//       const rect = videoContainer.getBoundingClientRect();
//       const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//       const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
      
//       // Position dropdown at bottom of video, centered
//       let dropdownTop = rect.bottom + scrollTop + 5;
//       let dropdownLeft = rect.left + scrollLeft + (rect.width / 2) - 80;
      
//       // Ensure dropdown stays within viewport
//       const dropdownWidth = 160;
//       const dropdownHeight = 100;
//       const viewportWidth = window.innerWidth;
//       const viewportHeight = window.innerHeight;
      
//       if (dropdownLeft < 10) {
//         dropdownLeft = 10;
//       }
//       if (dropdownLeft + dropdownWidth > viewportWidth - 10) {
//         dropdownLeft = viewportWidth - dropdownWidth - 10;
//       }
      
//       if (dropdownTop + dropdownHeight > viewportHeight + scrollTop) {
//         dropdownTop = rect.top + scrollTop - dropdownHeight - 5;
//       }
      
//       setDropdownPosition({ top: dropdownTop, left: dropdownLeft });
//       setSelectedVideo(videoContainer);
//       setShowImageDropdown(true); // Reuse the same dropdown
//     };
//   };

//   const changeTextColor = (color) => {
//     execCommand('foreColor', color);
//     setShowColorPicker(false);
//   };

//   const insertTable = () => {
//     const rows = prompt('Number of rows:', '3');
//     const cols = prompt('Number of columns:', '3');
//     if (rows && cols) {
//       let tableHTML = '<table border="1" style="border-collapse: collapse; width: 100%; margin: 8px 0;">';
//       for (let i = 0; i < parseInt(rows); i++) {
//         tableHTML += '<tr>';
//         for (let j = 0; j < parseInt(cols); j++) {
//           tableHTML += '<td style="padding: 8px; border: 1px solid #ccc; min-width: 100px;">&nbsp;</td>';
//         }
//         tableHTML += '</tr>';
//       }
//       tableHTML += '</table><p><br></p>';
//       execCommand('insertHTML', tableHTML);
//     }
//   };

//   const getCurrentImageProps = () => {
//     if (selectedVideo) {
//       // Handle video properties
//       const videoWidth = selectedVideo.style.width || '75%';
//       let size = '75';
      
//       if (videoWidth === '25%') size = '25';
//       else if (videoWidth === '50%') size = '50';
//       else if (videoWidth === '75%') size = '75';
//       else if (videoWidth === '100%') size = '100';

//       const float = selectedVideo.style.float || 'none';
//       const isCenter = selectedVideo.style.margin.includes('auto');
//       const alignment = isCenter ? 'center' : float;

//       return { size, alignment };
//     }
    
//     if (!selectedImage) return { size: '50', alignment: 'center' };
    
//     const maxWidth = selectedImage.style.maxWidth || '50%';
//     let size = '50';
    
//     if (maxWidth === '25%') size = '25';
//     else if (maxWidth === '50%') size = '50';
//     else if (maxWidth === '75%') size = '75';
//     else if (maxWidth === '100%') size = '100';

//     const float = selectedImage.style.float || 'none';
//     const isCenter = selectedImage.style.display === 'block' && selectedImage.style.margin.includes('auto');
//     const alignment = isCenter ? 'center' : float;

//     return { size, alignment };
//   };

//   const currentProps = (selectedImage || selectedVideo) ? getCurrentImageProps() : { size: '50', alignment: 'center' };

//   const colors = [
//     '#000000', '#444444', '#666666', '#999999', '#cccccc', '#eeeeee', '#f3f3f3', '#ffffff',
//     '#ff0000', '#ff9900', '#ffff00', '#00ff00', '#00ffff', '#0000ff', '#9900ff', '#ff00ff',
//     '#f4cccc', '#fce5cd', '#fff2cc', '#d9ead3', '#d0e0e3', '#cfe2f3', '#d9d2e9', '#ead1dc',
//     '#ea9999', '#f9cb9c', '#ffe599', '#b6d7a8', '#a2c4c9', '#9fc5e8', '#b4a7d6', '#d5a6bd'
//   ];

//   const sizeOptions = [
//     { value: '25', label: '25%' },
//     { value: '50', label: '50%' },
//     { value: '75', label: '75%' },
//     { value: '100', label: '100%' }
//   ];

//   const alignmentOptions = [
//     { value: 'left', icon: 'fas fa-align-left' },
//     { value: 'center', icon: 'fas fa-align-center' },
//     { value: 'right', icon: 'fas fa-align-right' },
//     { value: 'none', icon: 'fas fa-ban' }
//   ];

//   return (
//     <div>
//       <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css" />
      
//       <div className="blogger-editor-container">
//         <div className="blogger-editor-wrapper">
//           <div className="blogger-toolbar">
//             {/* Heading and Font Size */}
//             <div className="blogger-toolbar-group">
//               <select 
//                 className="blogger-select"
//                 onChange={(e) => formatHeading(e.target.value)}
//                 defaultValue="p"
//                 title="Format"
//               >
//                 <option value="p">Normal</option>
//                 <option value="1">Heading 1</option>
//                 <option value="2">Heading 2</option>
//                 <option value="3">Heading 3</option>
//                 <option value="4">Heading 4</option>
//                 <option value="5">Heading 5</option>
//                 <option value="6">Heading 6</option>
//               </select>
              
//               <select 
//                 className="blogger-select"
//                 onChange={(e) => execCommand('fontSize', e.target.value)}
//                 defaultValue="3"
//                 title="Font size"
//               >
//                 <option value="1">8pt</option>
//                 <option value="2">10pt</option>
//                 <option value="3">12pt</option>
//                 <option value="4">14pt</option>
//                 <option value="5">18pt</option>
//                 <option value="6">24pt</option>
//                 <option value="7">36pt</option>
//               </select>
//             </div>

//             {/* Formatting */}
//             <div className="blogger-toolbar-group">
//               <button 
//                 className={`blogger-toolbar-button ${activeFormats.bold ? 'active' : ''}`}
//                 onClick={() => execCommand('bold')} 
//                 title="Bold"
//               >
//                 <i className="fas fa-bold"></i>
//               </button>
//               <button 
//                 className={`blogger-toolbar-button ${activeFormats.italic ? 'active' : ''}`}
//                 onClick={() => execCommand('italic')} 
//                 title="Italic"
//               >
//                 <i className="fas fa-italic"></i>
//               </button>
//               <button 
//                 className={`blogger-toolbar-button ${activeFormats.underline ? 'active' : ''}`}
//                 onClick={() => execCommand('underline')} 
//                 title="Underline"
//               >
//                 <i className="fas fa-underline"></i>
//               </button>
//               <button 
//                 className={`blogger-toolbar-button ${activeFormats.strikeThrough ? 'active' : ''}`}
//                 onClick={() => execCommand('strikeThrough')} 
//                 title="Strikethrough"
//               >
//                 <i className="fas fa-strikethrough"></i>
//               </button>
//             </div>

//             {/* Colors */}
//             <div className="blogger-toolbar-group">
//               <div style={{position: 'relative'}}>
//                 <button 
//                   className="blogger-toolbar-button"
//                   onClick={() => setShowColorPicker(!showColorPicker)}
//                   title="Text color"
//                 >
//                   <i className="fas fa-palette"></i>
//                 </button>
//                 {showColorPicker && (
//                   <div className="color-picker" style={{top: '32px', left: '0'}}>
//                     {colors.map(color => (
//                       <div 
//                         key={color}
//                         className="color-square"
//                         style={{backgroundColor: color}}
//                         onClick={() => changeTextColor(color)}
//                         title={color}
//                       />
//                     ))}
//                   </div>
//                 )}
//               </div>
              
//               <button 
//                 className="blogger-toolbar-button"
//                 onClick={() => execCommand('removeFormat')}
//                 title="Remove formatting"
//               >
//                 <i className="fas fa-eraser"></i>
//               </button>
//             </div>

//             {/* Alignment */}
//             <div className="blogger-toolbar-group">
//               <button 
//                 className={`blogger-toolbar-button ${activeFormats.justifyLeft ? 'active' : ''}`}
//                 onClick={() => execCommand('justifyLeft')} 
//                 title="Align left"
//               >
//                 <i className="fas fa-align-left"></i>
//               </button>
//               <button 
//                 className={`blogger-toolbar-button ${activeFormats.justifyCenter ? 'active' : ''}`}
//                 onClick={() => execCommand('justifyCenter')} 
//                 title="Center"
//               >
//                 <i className="fas fa-align-center"></i>
//               </button>
//               <button 
//                 className={`blogger-toolbar-button ${activeFormats.justifyRight ? 'active' : ''}`}
//                 onClick={() => execCommand('justifyRight')} 
//                 title="Align right"
//               >
//                 <i className="fas fa-align-right"></i>
//               </button>
//               <button 
//                 className={`blogger-toolbar-button ${activeFormats.justifyFull ? 'active' : ''}`}
//                 onClick={() => execCommand('justifyFull')} 
//                 title="Justify"
//               >
//                 <i className="fas fa-align-justify"></i>
//               </button>
//             </div>

//             {/* Lists */}
//             <div className="blogger-toolbar-group">
//               <button 
//                 className={`blogger-toolbar-button ${activeFormats.insertUnorderedList ? 'active' : ''}`}
//                 onClick={() => execCommand('insertUnorderedList')} 
//                 title="Bullet list"
//               >
//                 <i className="fas fa-list-ul"></i>
//               </button>
//               <button 
//                 className={`blogger-toolbar-button ${activeFormats.insertOrderedList ? 'active' : ''}`}
//                 onClick={() => execCommand('insertOrderedList')} 
//                 title="Numbered list"
//               >
//                 <i className="fas fa-list-ol"></i>
//               </button>
//               <button 
//                 className="blogger-toolbar-button"
//                 onClick={() => execCommand('indent')} 
//                 title="Increase indent"
//               >
//                 <i className="fas fa-indent"></i>
//               </button>
//               <button 
//                 className="blogger-toolbar-button"
//                 onClick={() => execCommand('outdent')} 
//                 title="Decrease indent"
//               >
//                 <i className="fas fa-outdent"></i>
//               </button>
//             </div>

//             {/* Insert */}
//             <div className="blogger-toolbar-group">
//               <button 
//                 className="blogger-toolbar-button"
//                 onClick={insertLink} 
//                 title="Insert link"
//               >
//                 <i className="fas fa-link"></i>
//               </button>
//               <button 
//                 className="blogger-toolbar-button"
//                 onClick={insertYouTube} 
//                 title="Insert YouTube video"
//               >
//                 <i className="fab fa-youtube"></i>
//               </button>
//               <button 
//                 className="blogger-toolbar-button"
//                 onClick={handleImageUpload} 
//                 title="Insert image"
//               >
//                 <i className="fas fa-image"></i>
//               </button>
//               <button 
//                 className="blogger-toolbar-button"
//                 onClick={insertTable} 
//                 title="Insert table"
//               >
//                 <i className="fas fa-table"></i>
//               </button>
//             </div>

//             {/* Undo/Redo */}
//             <div className="blogger-toolbar-group">
//               <button 
//                 className="blogger-toolbar-button"
//                 onClick={() => execCommand('undo')} 
//                 title="Undo"
//               >
//                 <i className="fas fa-undo"></i>
//               </button>
//               <button 
//                 className="blogger-toolbar-button"
//                 onClick={() => execCommand('redo')} 
//                 title="Redo"
//               >
//                 <i className="fas fa-redo"></i>
//               </button>
//             </div>
//           </div>
          
//           {/* Editor Area */}
//           <div
//             ref={editorRef}
//             contentEditable
//             className="blogger-editor"
//             onInput={updateContent}
//             onKeyUp={checkActiveFormats}
//             onMouseUp={checkActiveFormats}
//             suppressContentEditableWarning={true}
//             placeholder="Start typing your content here..."
//             onClick={() => {
//               setShowColorPicker(false);
//               setShowImageDropdown(false);
//               // Remove image selection
//               const selectedImg = editorRef.current?.querySelector('.editor-image.selected');
//               if (selectedImg) {
//                 selectedImg.classList.remove('selected');
//               }
//               // Remove video selection
//               const selectedVid = editorRef.current?.querySelector('.video-container.selected');
//               if (selectedVid) {
//                 selectedVid.classList.remove('selected');
//               }
//               setTimeout(checkActiveFormats, 10);
//             }}
//           />
          
//           <input
//             ref={fileInputRef}
//             type="file"
//             accept="image/*"
//             onChange={insertImage}
//             style={{display: 'none'}}
//           />
//         </div>

//         {/* Image Dropdown */}
//         {showImageDropdown && selectedImage && (
//           <>
//             <div 
//               className="image-dropdown-backdrop"
//               onClick={() => {
//                 setShowImageDropdown(false);
//                 selectedImage.classList.remove('selected');
//               }}
//             />
            
//             <div 
//               className="image-dropdown"
//               style={{
//                 top: dropdownPosition.top,
//                 left: dropdownPosition.left
//               }}
//               onClick={(e) => e.stopPropagation()}
//             >
//               <div className="dropdown-section">
//                 <div className="dropdown-label">Size</div>
//                 <div className="size-buttons">
//                   {sizeOptions.map(size => (
//                     <button
//                       key={size.value}
//                       className={`size-button ${currentProps.size === size.value ? 'active' : ''}`}
//                       onClick={() => resizeImage(size.value)}
//                       title={`${size.label} width`}
//                     >
//                       {size.label}
//                     </button>
//                   ))}
//                 </div>
//               </div>

//               <div className="dropdown-section">
//                 <div className="dropdown-label">Alignment</div>
//                 <div className="alignment-buttons">
//                   {alignmentOptions.map(align => (
//                     <button
//                       key={align.value}
//                       className={`alignment-button ${currentProps.alignment === align.value ? 'active' : ''}`}
//                       onClick={() => alignImage(align.value)}
//                       title={align.value === 'none' ? 'No alignment' : `Align ${align.value}`}
//                     >
//                       <i className={align.icon}></i>
//                     </button>
//                   ))}
//                 </div>
//               </div>

//               <div className="dropdown-section">
//                 <div 
//                   className="remove-button"
//                   onClick={removeImage}
//                 >
//                   <i className="fas fa-trash"></i>
//                   Remove
//                 </div>
//               </div>
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default BloggerEditor;
import React, { useState, useMemo } from 'react';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ImageResize from 'quill-image-resize-module-react';

// Register the image resize module
Quill.register('modules/imageResize', ImageResize);

const ArticleEditor = () => {
  const [content, setContent] = useState('');

  const handleChange = (value) => {
    setContent(value);
    console.log('Content:', value);
  };

  const modules = useMemo(() => ({
    toolbar: [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'font': [] }],
      [{ 'size': ['small', false, 'large', 'huge'] }],
      [{ 'align': [] }],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'indent': '-1'}, { 'indent': '+1' }],
      ['link', 'image', 'video'],
      ['blockquote', 'code-block'],
      ['clean']
    ],
    imageResize: {
      parchment: Quill.import('parchment'),
      modules: ['Resize', 'DisplaySize']
    }
  }), []);

  const formats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image', 'video',
    'align', 'color', 'background',
    'code-block'
  ];

  return (
    <div style={{ padding: '20px' }}>
      <h2>Article Editor</h2>
      <div style={{ marginBottom: '20px' }}>
        <ReactQuill
          theme="snow"
          value={content}
          onChange={handleChange}
          modules={modules}
          formats={formats}
          style={{
            height: '600px',
            marginBottom: '80px'
          }}
          placeholder="Start typing your article content..."
        />
      </div>
      
      {/* CSS for image alignment and fixes */}
      <style jsx global>{`
        .ql-align-left {
          text-align: left;
        }
        .ql-align-center {
          text-align: center;
        }
        .ql-align-right {
          text-align: right;
        }
        .ql-align-justify {
          text-align: justify;
        }
        
        .ql-editor img {
          max-width: 100%;
          height: auto;
          vertical-align: top;
        }
        
        /* Fix image resize handles to stay within editor */
        .ql-editor .ql-image-resize {
          position: relative;
          display: inline-block;
        }
        
        .ql-image-resize > .ql-image-resize-toolbar {
          position: absolute !important;
          z-index: 1000;
        }
        
        /* Prevent resize handles from going outside editor */
        .ql-container {
          overflow: visible;
        }
        
        /* Make text align to top when next to images */
        .ql-editor p img {
          vertical-align: top;
          margin-right: 10px;
        }
      `}</style>
    </div>
  );
};

export default ArticleEditor;